var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortingArrows = function SvgSortingArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.193 13.308a.626.626 0 0 1 0 .884l-2.5 2.5a.626.626 0 0 1-.885 0l-2.5-2.5a.626.626 0 0 1 .885-.884l1.432 1.433V3.75a.625.625 0 0 1 1.25 0v10.991l1.433-1.433a.624.624 0 0 1 .885 0m7.5-7.5-2.5-2.5a.624.624 0 0 0-.885 0l-2.5 2.5a.625.625 0 1 0 .885.884l1.432-1.433V16.25a.625.625 0 0 0 1.25 0V5.259l1.433 1.433a.625.625 0 1 0 .884-.884"
  })));
};
export default SvgSortingArrows;